import { runClientComponent } from '../../_common/client/client-component-runner';
import { ManufacturerContentBtnComponent } from './manufacturer-content-btn.component';

runClientComponent({ ManufacturerContentBtnComponent });
